// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16hpv","col":"styles_col__4Y6VA"};